import { TemplateMail } from '@/enum/TemplateMail'
import { AlqIdentityToken } from './AlqIdentityToken'


export class AlqForgottenPass {    

    
    public userLogin:string
    public userPass:string
    public userNewPass:string
    public userEncryptedToken:string    
    public mtpId:TemplateMail|null

    constructor({userLogin = "",userPass = "",userNewPass = "",userEncryptedToken="", mtpId = null} = {}) {        
        
        this.userLogin = userLogin
        this.userPass = userPass
        this.userNewPass = userNewPass
        this.userEncryptedToken = userEncryptedToken
        this.mtpId = mtpId
    }
}